import { fetchProfiles } from 'flow/actions/profile-actions';
import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import useContact from 'flow/hooks/useContact';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import {
    getProfileCallerId,
    hasLandlineCallerId,
} from 'flow/utils/profile-utils';
import { generatePath } from 'flow/utils/router-utils';
import { useEffect } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { Redirect, useHistory, useParams } from 'react-router-dom';

const SettingsProfileChooser = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const dispatch = useAppDispatch();

    const { extensionKey, numberType } = useParams<{
        extensionKey: ExtensionKey;
        numberType?: 'fixed' | 'msisdn';
    }>();
    const { contact } = useContact(extensionKey);
    const { profiles } = useProfiles(extensionKey);

    useEffect(() => {
        if (!extensionKey) {
            return null;
        }
        dispatch(fetchProfiles(extensionKey));
    }, [extensionKey]);

    if (!profiles?.first()) {
        return <Loading />;
    }

    if (numberType === 'fixed' && !hasLandlineCallerId(profiles.first())) {
        return (
            <Redirect
                to={generatePath(routes['settings.callerid'], { extensionKey })}
            />
        );
    }

    return (
        <Page
            header="settings.profile_edit"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.callerid'], {
                        extensionKey,
                    }),
                )
            }
        >
            {profiles.map((profile) => {
                const secondaryText = getProfileCallerId(
                    i18next,
                    profile,
                    contact,
                    numberType === 'fixed'
                        ? 'fixedCallerIdType'
                        : 'mexCallerIdType',
                    numberType === 'fixed'
                        ? 'fixedMainNumber'
                        : 'mexMainNumber',
                );

                return (
                    <RouteLink
                        key={profile.get('key')}
                        to={generatePath(
                            routes[
                                'settings.callerid.profile.numberType.edit.profileKey'
                            ],
                            {
                                extensionKey,
                                profileKey: profile.get('key'),
                                numberType,
                            },
                        )}
                        description={secondaryText}
                    >
                        {profile.get('description')}
                    </RouteLink>
                );
            })}
        </Page>
    );
};

export default SettingsProfileChooser;
